import styled from 'styled-components'

export const StyledForm = styled.form`
  margin: ${({ theme }) => theme.gutter} 0;
`
